export class Jurisdictions   {
  constructor (public sourceId: string,
    public sourceType: string,
    public sourceSubType: string,
    public sourceName: string,
    public status: string,
    public statusReason: string,
    public addresss: string,
    public state: string,
    public zipCode: string,
    public phoneNbr: string,
    public faxPhoneNbr: string,
    public altPhoneNbr: string,
    public altFaxNumber: string,
    public emailAddress: string,
    public webAddress: string,
    public pfdSendMethod: string,
    public pfdRecvMethod: string,
    public workOrderFormat: string,
    public comments: string,
    public contact: string,
    public systemOwnerId: string) {}

  static createFromRequest(juris: any): Jurisdictions {
      return juris == null
        ? null
        : new Jurisdictions(juris.sourceId,
          juris.sourceType,
          juris.sourceSubType,
          juris.sourceName,
          juris.status,
          juris.statusReason,
          juris.address,
          juris.state,
          juris.zipCode,
          juris.phoneNbr,
          juris.altPhoneNbr,
          juris.faxPhoneNbr,
          juris.altFaxNumber,
          juris.emailAddress,
          juris.webAddress,
          juris.pfdSendMethod,
          juris.pfdRecvMethod,
          juris.workOrderFormat,
          juris.comments,
          juris.contact,
          juris.systemOwnerId);
    }
}




// WEBPACK FOOTER //
// ./src/models/jurisdictions.ts